import React, { useEffect, useState } from "react";
import TradingChart from "../components/invest/TradingChart";
import { TrendingUp, Shield, Lock, Download, X, ArrowUpRight, BarChart3, Globe } from "lucide-react";

const InvestPage = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    document.title = "Investor Relations & Q Coin — Quivix";
  }, []);

  const handleInvestAction = () => {
    setShowComingSoon(true);
  };

  const handleCloseComingSoon = () => {
    setShowComingSoon(false);
  };

  return (
    <div className="bg-black text-[#f5f5f7] min-h-screen pt-36 pb-24 font-sans selection:bg-blue-500/30">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        
        {/* Header Title & Pitch */}
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-mono mb-4">
            <TrendingUp className="w-3.5 h-3.5" /> QuivixDigital Telemetry & Ecosystem Reserve
          </div>
          <h1 className="text-4xl sm:text-6xl font-bold tracking-tight text-white font-heading">
            Ecosystem Metrics & QVC Token.
          </h1>
          <p className="mt-4 text-base text-[#86868b] leading-relaxed">
            QuivixDigital powers high-performance applications with 20-30ms latency across 18 dedicated servers for over 60,000+ active users.
          </p>
        </div>

        {/* Investment Highlights Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          <div className="apple-glass rounded-2xl p-5 border border-white/[0.08]">
            <span className="text-[11px] font-mono text-[#86868b] uppercase tracking-wider">Active Users</span>
            <div className="text-2xl font-bold text-white mt-2 font-heading">60K+ - 100K</div>
            <span className="text-[10px] text-emerald-400 font-mono mt-1 block">Active Ecosystem</span>
          </div>

          <div className="apple-glass rounded-2xl p-5 border border-white/[0.08]">
            <span className="text-[11px] font-mono text-[#86868b] uppercase tracking-wider">24h Real Volume</span>
            <div className="text-2xl font-bold text-emerald-400 mt-2 font-heading">$3,400 USD</div>
            <span className="text-[10px] text-emerald-400/80 font-mono mt-1 block">Verified Volume</span>
          </div>

          <div className="apple-glass rounded-2xl p-5 border border-white/[0.08]">
            <span className="text-[11px] font-mono text-[#86868b] uppercase tracking-wider">Dedicated Servers</span>
            <div className="text-2xl font-bold text-white mt-2 font-heading">18 Nodes</div>
            <span className="text-[10px] text-blue-400 font-mono mt-1 block">Global Network</span>
          </div>

          <div className="apple-glass rounded-2xl p-5 border border-white/[0.08]">
            <span className="text-[11px] font-mono text-[#86868b] uppercase tracking-wider">Network Latency</span>
            <div className="text-2xl font-bold text-white mt-2 font-heading">20 - 30ms</div>
            <span className="text-[10px] text-emerald-400 font-mono mt-1 block">Ultra Fast SLA</span>
          </div>
        </div>

        {/* Main Grid: Trading Chart & Actions */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Trading Chart Panel (2 Cols) */}
          <div className="lg:col-span-2 apple-glass rounded-3xl p-6 sm:p-8 border border-white/[0.08] flex flex-col justify-between">
            <div className="flex items-center justify-between pb-6 border-b border-white/[0.08]">
              <div>
                <span className="text-xs text-[#86868b] font-mono">ASSET TICKER</span>
                <h3 className="text-xl font-bold text-white font-heading flex items-center gap-2">
                  Q Coin (QVC / USD) <span className="text-xs text-emerald-400 font-mono bg-emerald-500/10 px-2 py-0.5 rounded-full">+4.82%</span>
                </h3>
              </div>
              <div className="flex items-center gap-2 text-xs font-mono text-[#86868b]">
                <BarChart3 className="w-4 h-4 text-blue-400" />
                Live Feed
              </div>
            </div>

            <div className="my-6 min-h-[350px]">
              <TradingChart coinId={1} />
            </div>

            <div className="pt-4 border-t border-white/[0.08] flex items-center justify-between text-xs text-[#86868b]">
              <span>Latency: 1.2ms</span>
              <span>Order Matching Engine: Active</span>
            </div>
          </div>

          {/* Action & Terminal Card */}
          <div className="flex flex-col gap-6">
            <div className="apple-glass rounded-3xl p-6 sm:p-8 border border-white/[0.08]">
              <h3 className="text-lg font-bold text-white font-heading mb-4">Trade QVC Token</h3>
              <p className="text-xs text-[#86868b] leading-relaxed mb-6">
                Institutional Liquidity Pool & Decentralized Reserve for the Quivix platform.
              </p>

              <div className="flex flex-col gap-3">
                <button
                  onClick={handleInvestAction}
                  className="w-full py-3.5 rounded-full bg-white text-black font-semibold text-xs hover:bg-neutral-200 transition-all shadow-[0_0_20px_rgba(255,255,255,0.2)] active:scale-95 flex items-center justify-center gap-2"
                >
                  <span>Acquire QVC Tokens</span>
                  <ArrowUpRight className="w-4 h-4" />
                </button>
                <button
                  onClick={handleInvestAction}
                  className="w-full py-3.5 rounded-full bg-white/[0.04] text-white border border-white/10 hover:bg-white/10 text-xs font-medium transition-all active:scale-95"
                >
                  Sell / Redeem Tokens
                </button>
              </div>

              <div className="mt-8 pt-6 border-t border-white/[0.08] flex flex-col gap-2.5 text-xs text-[#86868b]">
                <div className="flex items-center gap-2">
                  <Shield className="w-3.5 h-3.5 text-blue-400" /> SOC2 Type II Encrypted
                </div>
                <div className="flex items-center gap-2">
                  <Lock className="w-3.5 h-3.5 text-emerald-400" /> Multi-Sig Vault Protection
                </div>
                <div className="flex items-center gap-2">
                  <Globe className="w-3.5 h-3.5 text-amber-400" /> Global Settlement Network
                </div>
              </div>
            </div>

            {/* Investor Prospectus Download */}
            <div className="apple-glass rounded-3xl p-6 border border-white/[0.08] flex items-center justify-between gap-4">
              <div>
                <h4 className="text-sm font-bold text-white font-heading">Series A Deck (PDF)</h4>
                <p className="text-[11px] text-[#86868b] mt-0.5">Financial Audits & Roadmap</p>
              </div>
              <button
                onClick={handleInvestAction}
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/10 flex items-center justify-center text-white transition-all shrink-0"
              >
                <Download className="w-4 h-4" />
              </button>
            </div>
          </div>

        </div>

      </div>

      {/* Modal */}
      {showComingSoon && (
        <div
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-xl flex items-center justify-center p-4"
          onClick={handleCloseComingSoon}
        >
          <div
            className="apple-glass rounded-3xl p-8 max-w-md w-full border border-white/20 shadow-2xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseComingSoon}
              className="absolute top-6 right-6 text-[#86868b] hover:text-white p-1 rounded-full hover:bg-white/10 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="w-12 h-12 rounded-2xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center text-blue-400 mb-5">
              <TrendingUp className="w-6 h-6" />
            </div>

            <h3 className="text-xl font-bold text-white font-heading">Institutional Access Only</h3>
            <p className="text-xs text-[#86868b] mt-2 leading-relaxed">
              QVC Token trading and Series A allocation are currently restricted to accredited investors and whitelisted institutions in your jurisdiction.
            </p>

            <div className="mt-6 pt-6 border-t border-white/10 flex flex-col gap-3">
              <button
                onClick={handleCloseComingSoon}
                className="w-full py-3 rounded-full bg-white text-black font-semibold text-xs hover:bg-neutral-200 transition-all"
              >
                Acknowledge & Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvestPage;
